import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Routes the app when it's opened via a learnxops:// deep link. Desktop-only —
// window.deepLink is exposed by the Electron preload; on web it's undefined and
// this is a no-op. Must render inside the Router so useNavigate is available.
export default function DeepLinkListener() {
  const navigate = useNavigate();
  useEffect(() => {
    if (typeof window === 'undefined' || !window.deepLink) return undefined;
    window.deepLink.onNavigate((route) => {
      if (typeof route === 'string' && route.startsWith('/')) navigate(route);
    });
    return () => { try { window.deepLink.offNavigate(); } catch { /* noop */ } };
  }, [navigate]);
  return null;
}
